import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { globalFileIcon } from "../../../axiosInstance";
import { setProducts } from "../../server/Product.js";
import { setCurrentCategoryDispatch } from "../../server/Category";
import "./SubNavbar.scss";
import { use } from "react";
import { set } from "react-hook-form";

const SubNavbar = ({
  fatherSlug,
  currentSubCategory,
  currentCategories,
  level = 1,
  setPendingScrollSlug,
}) => {
  const { pathname } = useLocation();
  const [children, setChildren] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setChildren(null);
    setCurrentCategory(null);
  }, [pathname]);

  const handleCategoryClick = (slug) => {
    setPendingScrollSlug(slug);
  };

  const updateCurr = (slug) => {
    const curr = currentCategories.children.find((cat) => cat.slug === slug);
    if (curr) {
      if (curr.children.filter((cat) => !cat.isFamily).length !== 0) {
        dispatch(setCurrentCategoryDispatch(curr));
        setChildren(curr);
        setCurrentCategory(curr.slug);
      } else {
        dispatch(setCurrentCategoryDispatch(currentCategories));
        setCurrentCategory(null);
        setChildren(null);
      }
    } else {
      for (let cat of currentCategories.children) {
        for (let subCat of cat.children) {
          if (subCat.slug === slug) {
            dispatch(setCurrentCategoryDispatch(cat));
            setChildren(cat);
            setCurrentCategory(cat.slug);
            return;
          }
        }
      }
    }
  };

  useEffect(() => {
    if (currentSubCategory) {
      updateCurr(currentSubCategory);
    }
  }, [currentSubCategory]);

  return (
    <>
      <nav className={`sub-navbar level-${level}`}>
        <ScrollMenu
          LeftArrow={LeftArrow}
          RightArrow={RightArrow}
          RTL
          wrapperClassName="custom-scroll-wrapper"
          scrollContainerClassName="custom-scroll-container"
        >
          {currentCategories.children.map(
            (category) =>
              !category.isFamily &&
              category.status === "ACTIVE" && (
                <a
                  key={category.slug}
                  className={`sub-navbar-item ${category.slug === currentCategory || category.slug === currentSubCategory ? "active" : ""}`}
                  onClick={() => handleCategoryClick(category.slug)}
                >
                  {category.name}
                </a>
              ),
          )}
        </ScrollMenu>
      </nav>
      {children &&
        children.children.filter((cat) => !cat.isFamily).length !== 0 && (
          <SubNavbar
            fatherSlug={currentCategory}
            currentSubCategory={currentSubCategory}
            currentCategories={children}
            level={level + 1}
            setPendingScrollSlug={setPendingScrollSlug}
          />
        )}
    </>
  );
};

const ArrowButton = ({ children, disabled, onClick, className }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`custom-arrow-btn ${className}`}
    >
      {children}
    </button>
  );
};

const LeftArrow = () => {
  const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);
  return (
    <ArrowButton
      disabled={isLastItemVisible}
      onClick={() => scrollNext()}
      className="left-arrow"
    >
      <img
        src={globalFileIcon + "open-cart.svg"}
        alt="scroll left"
        className="rotate-90"
      />
    </ArrowButton>
  );
};

const RightArrow = () => {
  const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);
  return (
    <ArrowButton
      disabled={isFirstItemVisible}
      onClick={() => scrollPrev()}
      className="right-arrow"
    >
      <img
        src={globalFileIcon + "open-cart.svg"}
        alt="scroll right"
        className="rotate-270"
      />
    </ArrowButton>
  );
};

export default SubNavbar;
